import { Box, SubNav as SubNav$1, StateLabel as StateLabel$1, ToggleSwitch as ToggleSwitch$1 } from '@primer/react';
export { ActionList, ActionMenu, Autocomplete, Avatar, Box, Breadcrumbs, Button, Checkbox, CheckboxGroup, CircleBadge, CounterLabel, Details, Dialog, Flash, FormControl, Header, Heading, IconButton, Label, Link, LinkButton, NavList, Overlay, PageHeader, PageLayout, Popover, ProgressBar, RadioGroup, RelativeTime, SegmentedControl, Select, Spinner, Text, TextInput, Textarea, ThemeProvider, Timeline, Token, Tooltip, Truncate, UnderlineNav, merge, sx, theme, themeGet, useColorSchemeVar, useTheme } from '@primer/react';
import { forwardRef } from 'react';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const StateLabel = /*#__PURE__*/forwardRef(function StateLabel(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: StateLabel$1,
    ref: ref
  }, props));
});
const SubNavImpl = /*#__PURE__*/forwardRef(function SubNav(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: SubNav$1,
    ref: ref
  }, props));
});
const SubNavLink = /*#__PURE__*/forwardRef(function SubNavLink(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: SubNav$1.Link,
    ref: ref
  }, props));
});
const SubNav = Object.assign(SubNavImpl, {
  Link: SubNavLink
});
const ToggleSwitch = /*#__PURE__*/forwardRef(function ToggleSwitch(props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: ToggleSwitch$1,
    ref: ref
  }, props));
});

export { StateLabel, SubNav, ToggleSwitch };
